import { render, staticRenderFns } from "./ValidationPending.vue?vue&type=template&id=563d910b&scoped=true"
import script from "./ValidationPending.vue?vue&type=script&lang=js"
export * from "./ValidationPending.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563d910b",
  null
  
)

export default component.exports